// InfoSection.js
import React from 'react'

export const InfoSection = ({ title, text, text2, list, imgSrc, reverse }) => (
  <div
    className={`flex flex-row justify-center items-center w-full ${
      reverse ? 'flex-row-reverse' : ''
    } mobile:flex-col tablet:flex-col`}
  >
    <div className='flex-1 px-2.5 mobile:px-0 tablet:px-0 w-1/2 mobile:w-full tablet:w-full'>
      <p className='text-[22px] font-bold mb-5 mobile:text-[22px] mobile:mt-4 text-[#181B2C]'>
        {title}
      </p>
      <p className='text-justify text-[16px] text-[#181B2C]'>{text}</p>
      {list &&
        list.map((item) => (
          <ul className='text-justify text-[16px] text-black'>
            <li className='ml-5 text-[14px] mt-2' >{item}</li>
          </ul>
        ))}
      <p className='text-justify text-[16px] text-[#181B2C]'>{text2}</p>
    </div>
    <div className='flex w-1/2 px-10 mobile:px-0 justify-center items-center mobile:w-full'>
      <img
        src={imgSrc}
        className='h-[300px] mobile:h-full tablet:h-full'
        alt={title}
      />
    </div>
  </div>
)
